import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'brand-stocktwits', 'BrandStocktwits', [["path",{"d":"M16 3l-8 4.5l8 4.5"}],["path",{"d":"M8 12l8 4.5l-8 4.5"}]]);